'use client'

import type {ReactNode} from 'react'
import {IntlProvider} from 'react-intl'
import enFormMessages from '@/i18n/forms/en.json'
import enCaFormMessages from '@/i18n/forms/en-CA.json'
import nbNoFormMessages from '@/i18n/forms/nb-NO.json'
import svSeFormMessages from '@/i18n/forms/sv-SE.json'
import frFrFormMessages from '@/i18n/forms/fr-FR.json'
import frCaFormMessages from '@/i18n/forms/fr-CA.json'
import deDeFormMessages from '@/i18n/forms/de-DE.json'
import esEsFormMessages from '@/i18n/forms/es-ES.json'
import itItFormMessages from '@/i18n/forms/it-IT.json'
import plPlFormMessages from '@/i18n/forms/pl-PL.json'
import nlNlFormMessages from '@/i18n/forms/nl-NL.json'
import fiFiFormMessages from '@/i18n/forms/fi-FI.json'
import daDkFormMessages from '@/i18n/forms/da-DK.json'
import csCzFormMessages from '@/i18n/forms/cs-CZ.json'
import enMessages from '@/i18n/en.json'
import enCaMessages from '@/i18n/en-CA.json'
import nbNoMessages from '@/i18n/nb-NO.json'
import svSeMessages from '@/i18n/sv-SE.json'
import frFrMessages from '@/i18n/fr-FR.json'
import frCaMessages from '@/i18n/fr-CA.json'
import deDeMessages from '@/i18n/de-DE.json'
import esEsMessages from '@/i18n/es-ES.json'
import itItMessages from '@/i18n/it-IT.json'
import plPlMessages from '@/i18n/pl-PL.json'
import nlNlMessages from '@/i18n/nl-NL.json'
import fiFiMessages from '@/i18n/fi-FI.json'
import daDkMessages from '@/i18n/da-DK.json'
import csCzMessages from '@/i18n/cs-CZ.json'

const messagesByLocale: Record<string, Record<string, string>> = {
  en: {...enMessages, ...enFormMessages},
  'en-US': {...enMessages, ...enFormMessages},
  'en-GB': {...enMessages, ...enFormMessages},
  'en-CA': {...enCaMessages, ...enCaFormMessages},
  'nb-NO': {...nbNoMessages, ...nbNoFormMessages},
  'sv-SE': {...svSeMessages, ...svSeFormMessages},
  'fr-FR': {...frFrMessages, ...frFrFormMessages},
  'fr-CA': {...frCaMessages, ...frCaFormMessages},
  'de-DE': {...deDeMessages, ...deDeFormMessages},
  'es-ES': {...esEsMessages, ...esEsFormMessages},
  'it-IT': {...itItMessages, ...itItFormMessages},
  'pl-PL': {...plPlMessages, ...plPlFormMessages},
  'nl-NL': {...nlNlMessages, ...nlNlFormMessages},
  'fi-FI': {...fiFiMessages, ...fiFiFormMessages},
  'da-DK': {...daDkMessages, ...daDkFormMessages},
  'cs-CZ': {...csCzMessages, ...csCzFormMessages},
}

type IntlProviderClientProps = {
  locale: string
  children: ReactNode
}

export function IntlProviderClient({locale, children}: IntlProviderClientProps) {
  return (
    <IntlProvider
      locale={locale}
      defaultLocale="en"
      messages={messagesByLocale[locale] || messagesByLocale.en}
    >
      {children}
    </IntlProvider>
  )
}
